var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('img',{staticClass:"cp ml_auto",attrs:{"src":"/img/icons/download.svg","alt":""},on:{"click":_vm.downloadDocument}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }